/* eslint-disable @typescript-eslint/no-use-before-define */
import InputRadio, { InputRadioGroup } from '../Input/InputRadio';
import InputText from '../Input/InputText';
import {
  AnniProjectActionType,
  getAnniStateCss,
  getAnniEndDDay,
  getAnniGoalAmountPer,
} from '../Layer/AnniProject/AnniProjectPopupInterface';
import SwiperBasic from '../Swiper/SwiperBasic';
import { Tit } from '../Titles';
import {
  AnniversaryProjectControllerService,
  anniversaryProjectVo,
} from '@/__generated__/FrontApi';
import IconSearch from '@/assets/img/icons/ico_search@2x.png';
import Sec4Lock from '@/assets/img/involve/together_bg4_lock.png';
import Sec4bg1 from '@/assets/img/involve/together_sec4_bg1.png';
import Sec4Pin from '@/assets/img/involve/together_sec4_pin@2x.png';
import SectionHeader from '@/components/SectionHeader';
import { breakpoint } from '@/helpers/BreakpointHelper';
import { useUserStore } from '@/stores/UserStore';
import moment from 'moment';
import React, {
  FC,
  ReactElement,
  useState,
  useCallback,
  useEffect,
} from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import styled from 'styled-components';
import SwiperCore, { A11y, Autoplay, Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/scrollbar/scrollbar.min.css';
import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.css';

SwiperCore.use([Navigation, Scrollbar, A11y, Autoplay]);

interface TogeterTabProps {
  type: string; // 탭 타입
  reqDetail?: any; // 상세페이지 요청 함수
  reqAid?: number;
}
interface SearchFormData {
  keyword: string;
  category: string;
  displayState: string;
}
const LoginReq = styled.div``;
const SearchSection = styled.div``;
const InputRadioGroupWrap = styled.div``;
const InputTextGroup = styled.div``;
const SectionHeaderWrap = styled.div`
  ${SectionHeader} {
    padding-bottom: 117px;
    text-align: left;
    ${breakpoint(`tablet`)} {
      & > p {
        font-size: 1.81vw;
        color: red;
      }
    }
    ${breakpoint(`mobile`)} {
      padding-bottom: 100px !important;
      ${Tit} {
        line-height: 1.27;
        .br_m {
          display: none;
        }
      }
    }
    ${breakpoint(452)} {
      padding-bottom: 95px !important;
      ${Tit} {
        // min-height: 76px;
        .br_m {
          display: block;
        }
      }
    }
  }
`;
const Page = styled.div`
  ${LoginReq} {
    padding-top: 70px;
    text-align: center;
    img {
      width: 59px;
      height: auto;
    }
    p {
      font-family: 'NEXON Lv1';
      font-size: 34px;
      color: #fff;
      font-weight: 700;
      padding: 50px 0 30px;
    }
    a {
      display: inline-block;
      width: 261px;
      height: 62px;
      line-height: 60px;
      text-align: center;
      color: #1dabe1;
      border: 1px solid #1dabe1;
      border-radius: 31px;
      font-size: 24px;
      font-weight: 700;
      transition: all 0.2s;

      &:hover {
        background: #1dabe1;
        color: #fff;
      }
    }
    ${breakpoint(`mobile`)} {
      padding-top: 30px;
      img {
        width: 35px;
      }
      p {
        font-size: 22px;
        padding: 30px 0 20px;
      }
      a {
        width: 170px;
        height: 39px;
        line-height: 37px;
        font-size: 17px;
      }
    }
  }

  ${SearchSection} {
    ${InputRadioGroupWrap} {
      ${InputRadioGroup} {
        text-align: left;
        .search-state {
          width: 100px;
          min-width: 100px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 20px;
          &:not(:last-of-type) {
            margin: 0 15px 0 0;
          }
          .btn {
            height: 40px;
            line-height: 40px;
            border-radius: 20px;
            color: #fff;
            border: 0;
          }
        }
      }
    }
    ${InputTextGroup} {
      position: relative;
      margin: 20px 0 50px 0;
      ${InputText} {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 32px;
        font-family: 'NEXON Lv1';
        font-size: 26px;
        font-weight: 700;
        color: #fff;
        height: 64px;
        padding: 4px 78px 0 38px;
      }
      button {
        position: absolute;
        top: 0;
        right: 28px;
        width: 50px;
        height: 64px;
        img {
          width: 25px;
        }
      }
    }
    ${breakpoint(`mobile`)} {
      ${InputRadioGroupWrap} {
        ${InputRadioGroup} {
          .search-state {
            width: 75px;
            min-width: 75px;
            &:not(:last-of-type) {
              margin: 0 10px 5px 0;
            }
            &:last-of-type {
              margin: 0 0 5px 0;
            }
            .btn {
              height: 30px;
              line-height: 30px;
            }
          }
        }
      }
      ${InputTextGroup} {
        margin: 15px 0 30px 0;
        ${InputText} {
          border-radius: 21px;
          font-size: 18px;
          height: 42px;
          padding: 3px 42px 0 20px;
        }
        button {
          right: 17px;
          width: 25px;
          height: 42px;
          img {
            width: 17px;
          }
        }
      }
    }
  }
`;

const setReqDetailHandler = (argId: number, argProps: any) => {
  argProps.reqDetail(argId);
};

const setReqDetailParentsHandler = (
  argId: number,
  argPage: AnniProjectActionType,
  argProps: any,
) => {
  argProps.reqDetail(argId, argPage);
};

const SwiperTemplete: FC<TogeterTabProps> = ({ type, ...props }) => {
  const [hover, setHover] = useState(0);
  const [searchType] = useState(type);
  const [searchWord, setSearchWord] = useState('');
  const [searchDisplayState, setSearchDisplayState] = useState('');
  // 검색 영역
  const { register, handleSubmit } = useForm<SearchFormData>();
  const handelRadioChange = (ev: any) => {
    setSearchDisplayState(ev.target.value);
  };
  const onSubmit: SubmitHandler<SearchFormData> = ({ keyword }) => {
    setSearchWord(keyword);
    return false;
  };

  // 기념기부 목록 로딩
  const [projectItems, setProjectItems] = useState<any[]>([]);
  const loadProject = useCallback(async () => {
    AnniversaryProjectControllerService.selectAnniversaryProjectListUsingGet({
      type: searchType,
      keyword: searchWord,
      displayState: searchDisplayState,
    })
      .then(({ data, resultCode }) => {
        setProjectItems([]);
        if (resultCode === `success`) {
          const item = data as anniversaryProjectVo[];
          setProjectItems(item);
        }
      })
      .catch(() => {
        setProjectItems([]);
      });
  }, [searchWord, searchType, searchDisplayState]);
  useEffect(() => {
    loadProject();
  }, [searchType, searchWord, loadProject]);

  return (
    <>
      {/* ********** 검색 영역 */}
      <SearchSection>
        <form onSubmit={handleSubmit(onSubmit)}>
          <InputRadioGroupWrap>
            <InputRadioGroup>
              <InputRadio
                name="displayState"
                ref={register}
                tab
                value=""
                label="전체"
                defaultChecked
                className="search-state"
                onChange={handelRadioChange}
              />
              <InputRadio
                name="displayState"
                ref={register}
                tab
                value="3"
                label="진행 중"
                className="search-state"
                onChange={handelRadioChange}
              />
              <InputRadio
                name="displayState"
                ref={register}
                tab
                value="4"
                label="종료"
                className="search-state"
                onChange={handelRadioChange}
              />
              {/* 230607 담당자 요청으로 필터링 숨김처리
              {type === 'admin' ? (
                <>
                  <InputRadio
                    name="displayState"
                    ref={register}
                    tab
                    value="0"
                    label="대기"
                    className="search-state"
                    onChange={handelRadioChange}
                  />
                  <InputRadio
                    name="displayState"
                    ref={register}
                    tab
                    value="1"
                    label="수정"
                    className="search-state"
                    onChange={handelRadioChange}
                  />
                  <InputRadio
                    name="displayState"
                    ref={register}
                    tab
                    value="2"
                    label="보류"
                    className="search-state"
                    onChange={handelRadioChange}
                  />
                </>
              ) : (
                <></>
              )}
              */}
            </InputRadioGroup>
          </InputRadioGroupWrap>
          <InputTextGroup>
            <InputText
              placeholder="검색어를 입력하세요"
              name="keyword"
              ref={register}
            />
            <button type="submit" title="검색하기">
              <img src={IconSearch} alt="검색버튼" />
            </button>
          </InputTextGroup>
        </form>
      </SearchSection>
      {/* ********** 목록 출력 */}
      <SwiperCustom {...props} overflowHidden>
        <Swiper
          // 모바일 default
          slidesPerView={1}
          slidesPerColumn={2}
          slidesPerGroup={1}
          spaceBetween={25}
          slidesPerColumnFill="row"
          navigation
          scrollbar={{ draggable: true }}
          onSwiper={(swiper) => {
            setTimeout(() => {
              swiper.update(); // ------> this solution
            }, 3000);
          }}
          breakpoints={{
            // 태블릿
            641: {
              slidesPerView: 2,
              slidesPerGroup: 1,
              slidesPerColumn: 2,
              spaceBetween: 30,
              slidesPerColumnFill: 'row',
            },
            // PC
            1160: {
              slidesPerView: 3,
              slidesPerGroup: 1,
              slidesPerColumn: 2,
              spaceBetween: 30,
              slidesPerColumnFill: 'row',
            },
          }}
        >
          {projectItems.map((items: anniversaryProjectVo) => (
            <SwiperSlide
              key={items.aprjtIdx}
              onMouseEnter={() => setHover(1)}
              onMouseLeave={() => setHover(0)}
            >
              <CardLayout className="CardLayout">
                <button
                  type="button"
                  onClick={() => {
                    setReqDetailHandler(items.aprjtIdx || 0, props);
                  }}
                >
                  <div className="dec-wrap">
                    <CardBadge>
                      {getAnniGoalAmountPer(
                        items.goalAmount || 0,
                        items.giftTotalAmount || 0,
                      ) > 100 ? (
                        <i className="ico-goal-over">
                          {getAnniGoalAmountPer(
                            items.goalAmount || 0,
                            items.giftTotalAmount || 0,
                          )?.toLocaleString()}
                          % 달성
                        </i>
                      ) : (
                        <></>
                      )}
                      <i className="ico-goal-count">
                        {(items.giftCountSupport || 0)?.toLocaleString()}명 참여
                      </i>
                    </CardBadge>
                    <CardTitle className="nxnFont">
                      <Tit
                        size="s4"
                        className={`${hover !== 0 ? 'underline' : ''}`}
                      >
                        <i
                          className={`ico-state ${getAnniStateCss(
                            items.displayStateTypeCode || '',
                          )}`}
                        >
                          {items.displayStateTypeName || ''}{' '}
                        </i>
                        {items.aprjtName || ''}
                      </Tit>
                      <span className={`${hover !== 0 ? 'underline' : ''}`}>
                        {items.registerName}
                      </span>
                    </CardTitle>

                    <CardList>
                      <li>
                        <span>목표기간 :&nbsp;</span>
                        {items.goalStartDate
                          ? moment(items.goalStartDate).format('YYYY.MM.DD')
                          : ''}
                        &nbsp;-&nbsp;
                        {items?.goalEndDate
                          ? moment(items.goalEndDate).format('YYYY.MM.DD')
                          : ''}
                        {items.displayStateTypeCode === '3' &&
                        getAnniEndDDay(items.goalEndDate || '') > 0 ? (
                          <i className="ico-dday">
                            D-{getAnniEndDDay(items.goalEndDate || '')}
                          </i>
                        ) : (
                          <></>
                        )}
                      </li>
                      <li>
                        <span>목표금액 :&nbsp;</span>
                        {items.goalAmount?.toLocaleString() || 0}원
                      </li>
                      <li>
                        <span>현재 후원금액 :&nbsp;</span>
                        {items.giftTotalAmount?.toLocaleString() || 0}원
                      </li>
                    </CardList>
                  </div>
                </button>
              </CardLayout>
            </SwiperSlide>
          ))}
        </Swiper>
      </SwiperCustom>
    </>
  );
};

const AllProject: FC<TogeterTabProps> = ({ type, ...props }) => (
  <Page>
    {/* 전체페이지 목록 */}
    <SwiperTemplete
      type={type}
      reqDetail={(id: number) => {
        setReqDetailHandler(id, props);
      }}
    />
  </Page>
);
const MyProject: FC<TogeterTabProps> = ({ type, ...props }) => {
  const userStore = useUserStore();
  useEffect(() => {
    // 로그인 여부 확인
  }, [userStore.user]);
  return (
    <Page>
      {!userStore.isLoggedIn() ? (
        /* 로그인 요구문구 */
        <LoginReq>
          <img src={Sec4Lock} alt="로그인 필요" />
          <p>로그인이 필요합니다.</p>
          <a href="/auth/login/?redirectTo=/involve/individual/together/">
            로그인 하러가기
          </a>
        </LoginReq>
      ) : (
        /* 내 페이지 목록 */
        <SwiperTemplete
          type={type}
          reqDetail={(id: number) => {
            setReqDetailHandler(id, props);
          }}
        />
      )}
    </Page>
  );
};
const CardBadge = styled.p``;
const CardTitle = styled.p``;
const CardList = styled.ul``;
const CardLayout = styled.div`
  padding: 30px;
  position: relative;
  &::after {
    content: '';
    display: block;
    width: 28px;
    height: 28px;
    background: url(${Sec4Pin}) no-repeat;
    background-size: contain;
    position: absolute;
    top: 7px;
    right: 6px;
  }
  button {
    width: 100%;
  }
  ${CardBadge} {
    text-align: left;
    i {
      font-family: 'NEXON Lv1', sans-serif;
      font-style: normal;
      vertical-align: middle;
      &:not(:first-of-type) {
        margin-left: 8px;
      }
      &.ico-goal-over {
        color: #1cabe2;
        font-size: 16px;
        font-weight: 700;
      }
      &.ico-goal-count {
        color: #999;
        font-size: 12px;
        font-weight: 500;
        background: #f5f5f5;
        border-radius: 10px;
        line-height: 18px;
        padding: 0 11px;
        display: inline-block;
      }
    }
  }

  ${CardTitle} {
    text-align: left;
    margin: 8px 0 0 0;
    & > * {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      line-height: normal;
      width: 100%;
    }
    ${Tit} {
      font-size: 20px;
      display: block;
      & i.ico-state {
        font-family: 'NEXON Lv1 Regular', sans-serif;
        font-weight: 100;
        font-style: normal;
        font-size: 14px;
        background-color: #999;
        color: #fff;
        border-radius: 5px;
        padding: 0 5px;
        margin-right: 10px;
        display: inline-block;
        vertical-align: middle;
        line-height: 22px;

        &.ico-state-wait {
          background-color: #374ea2;
        }
        &.ico-state-edit {
          background-color: #ffc20e;
        }
        &.ico-state-defer {
          background-color: #2d2926;
        }
        &.ico-state-ing {
          background-color: #1cabe2;
        }
        &.ico-state-end {
          background-color: #999;
        }
      }
    }
    span {
      font-weight: 500;
      font-size: 16px;
      width: fit-content;
      margin-top: 10px;
      display: block;
    }
  }

  ${CardList} {
    margin-top: 13px;

    li {
      font-family: 'Noto Sans CJK KR';
      font-size: 16px;
      letter-spacing: -0.5px;
      position: relative;
      display: flex;
      align-items: center;
      padding-left: 12px;
      line-height: 23px;
      color: #555555;

      span {
        flex-shrink: 0;
      }

      .ico-dday {
        color: #1cabe2;
        font-size: 12px;
        font-family: 'NEXON Lv1', sans-serif;
        font-style: normal;
        background: #e8f6fc;
        border-radius: 5px;
        line-height: 20px;
        padding: 0 5px;
        margin-left: 7px;
        white-space: nowrap;
      }

      &:before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 4px;
        background: #555555;
        border-radius: 100%;
        position: absolute;
        left: 0;
      }
    }
  }

  &:hover {
    ${CardTitle} {
      color: #374ea2;

      .underline::after {
        opacity: 0.3;
        height: 10px;
        background: #1cabe2;
      }
    }

    ${CardList} {
      li {
        color: #374ea2;
      }
    }
  }
  ${breakpoint(`mobile`)} {
    padding: 20px 25px;
    &::after {
      width: 19px;
      height: 19px;
      top: 5px;
      right: 5px;
    }
    ${CardBadge} {
      i {
        &.ico-goal-over {
          font-size: 13px;
        }
        &.ico-goal-count {
          font-size: 11px;
          border-radius: 8px;
          padding: 0 9px;
        }
      }
    }
    ${CardTitle} {
      ${Tit} {
        font-size: 15px;
        & i.ico-state {
          padding: 0 5px;
          font-size: 12px;
          line-height: 18px;
          border-radius: 2.5px;
        }
      }
      span {
        font-size: 13px;
        margin-top: 8px;
      }
    }
    ${CardList} {
      margin-top: 10px;
      li {
        font-size: 13px;
        padding-left: 7px;
        align-items: flex-start;
        line-height: 20px;
        span {
          width: auto;
          flex-shrink: 0;
        }
        .ico-dday {
          font-size: 10px;
          padding: 0 4px;
          margin-left: 4px;
        }
        &:before {
          width: 3px;
          height: 3px;
          top: 9px;
        }
      }
    }
  }
`;

const SwiperCustom = styled(SwiperBasic)`
  padding: 0;
  .swiper-wrapper {
    height: auto;
  }
  .swiper-container {
    padding: 0 0 105px;
    height: 573px;

    .swiper-scrollbar {
      bottom: 26px;
      &::before {
        opacity: 1;
        background: #fff;
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      bottom: 0;
      transform: translateX(35px);
    }

    .swiper-slide {
      overflow: hidden;
      width: calc(100% / 3);
      margin-right: 40px;
      background: url(${Sec4bg1}) 50% 50% no-repeat;
      background-size: cover;
      height: 219px;
    }
  }
  ${breakpoint(1160)} {
    .swiper-container {
      height: auto;
      .swiper-button-next,
      .swiper-button-prev {
        transform: translateX(0);
      }
      .swiper-slide {
        width: calc(100% / 2);
        background-size: 100% 100%;
        background-position: 100% 100%;
      }
    }
  }
  ${breakpoint(`mobile`)} {
    padding: 0 9.33vw;
    .swiper-container {
      height: auto;

      .swiper-scrollbar {
        left: 0;
        width: 100%;
        &::before {
          width: 100%;
        }
      }

      .swiper-slide {
        height: auto;
        margin-right: 0;
        background: url(${Sec4bg1}) 50% 0 no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  ${breakpoint(370)} {
    padding: 0 5.56vw;
  }
`;

const Nav = styled.div`
  display: flex;
  justify-content: center;
`;

const List = styled.ul<{ active: any }>`
  display: flex;
  width: 100%;
  max-width: 1120px;
  font-size: 18px;
  color: #ffffff;
  position: absolute;
  top: 345px; 
  left: 50%;
  transform: translateX(-50%);
  z-index:10;
  &::after {
    content: '';
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 1px;
    background: #fff;
    opacity: 0.3;
    z-index: 0;
    left: 0;
  }
  ${breakpoint(1160)} {
    width: calc(100% - 40px);
  }
  ${breakpoint(`tablet`)} {
    top: 340;
  }
  ${breakpoint(`mobile`)} {
    font-size: 14px;
    top: ${(props) => (props.active === 1 ? `250px` : `250px`)};
  }
  ${breakpoint(452)} {
    top: ${(props) => (props.active === 1 ? `245px` : `283px`)};
  }
}
`;

const Tab = styled.li<{ active: boolean }>`
  padding-bottom: 8px;
  margin-right: 42px;
  line-height: 1;
  z-index: 1;
  cursor: pointer;
  opacity: ${(props) => (props.active ? `1` : `.5`)};
  color: ${(props) => (props.active ? `#1cabe2` : `none`)};
  border-bottom: ${(props) => (props.active ? `4px solid #1cabe2` : `none`)};
  ${breakpoint(`mobile`)} {
    margin-right: 23px;
  }
`;

const MainNav: FC<TogeterTabProps> = ({ ...props }) => {
  const tabTitle = [`전체 페이지`, `내 페이지`];
  const tab: { [key: number]: ReactElement } = {
    0: (
      <AllProject
        type="use"
        reqDetail={(id: number) => {
          setReqDetailParentsHandler(id, AnniProjectActionType.detail, props);
        }}
      />
    ),
    1: (
      <MyProject
        type="admin"
        reqDetail={(id: number) => {
          setReqDetailParentsHandler(id, AnniProjectActionType.admin, props);
        }}
      />
    ),
  };

  const [activeTab, setActiveTab] = useState(0);
  const userStore = useUserStore();
  const handleTabMenu = (id: number) => {
    setActiveTab(id);
  };

  useEffect(() => {
    // 로그인 여부 확인
  }, [userStore.user]);

  return (
    <>
      <SectionHeaderWrap>
        <SectionHeader className="with-desc">
          {activeTab === 1 ? (
            <>
              {/* 내 기념기부 */}
              <h2>
                <Tit size="s1" weight="black" className="nxnFont" color="white">
                  <span className="underline">내가 만든 페이지</span> 찾기
                </Tit>
              </h2>
              <p>
                ‘같이 하는 기념기부’에 참여하셨나요?
                <br />
                지금까지 만든 ‘같이 하는 기념기부’ 페이지를 확인하고
                <br className="br_m" /> 가족, 친구에게 받은 따듯한 메시지를
                <br className="br_m" /> 다시 확인하실 수 있습니다.
              </p>
            </>
          ) : (
            <>
              {/* 전체 */}
              <h2>
                <Tit size="s1" weight="black" className="nxnFont" color="white">
                  <span className="underline">소중한 사람/기관의 </span>
                  <br className="br_m" />
                  <span className="underline">이름</span>을 찾아보세요
                </Tit>
              </h2>
              <p>
                친구의 ‘같이 하는 기념기부’ 페이지를 찾고 계신가요?
                <br className="br_m" /> 팬클럽, 기관의 기념기부에 함께 참여하고
                싶으신가요?
                <br />
                아래에서 이름을 검색하고 친구, 스타, 기관 등
                <br className="br_m" /> 소중한 사람을 위한 같이 기부에
                참여해보세요
              </p>
            </>
          )}
        </SectionHeader>
      </SectionHeaderWrap>
      <Nav className="nxnFont">
        <List active={activeTab}>
          {tabTitle.map((title, idx) => (
            <Tab
              active={activeTab === idx}
              key={title}
              onClick={() => handleTabMenu(idx)}
            >
              {title}
            </Tab>
          ))}
        </List>
      </Nav>
      {tab[activeTab]}
    </>
  );
};

export default MainNav;
